import { Properties, TimeSlot, Visit, VisitsState } from './types';
import { Claim } from '../claim/types';
import { ReduxAction, setAsyncData } from '../core';

import { VisitsAction } from './actions';
import { UIAction } from '../ui/actions';
import { ClaimsAction } from '../claim/actions';
import { distanceBetweenLocations } from '../../util/Address';

const initialState: VisitsState = {
  visits: { isFetching: false },
  visitCodeToVisitIndex: {},
  visitConfig: { isFetching: false },
  availableTimeSlots: { isFetching: false },
  visitSideCardClaim: undefined,
};

function updateVisitDuplicateAddress(visits: Visit[], index: number) {
  for (let i = 0; i < visits.length; i++) {
    if (i !== index && distanceBetweenLocations(visits[i].latitudeAddress, visits[i].longitudeAddress, visits[index].latitudeAddress, visits[index].longitudeAddress) < 0.02) {
      visits[i].duplicateAddress = visits[index].duplicateAddress = true;
    }
  }

  return visits;
}

function updateVisitsDuplicateAddress(visits: Visit[]) {
  for (let i = 0; i < visits.length; i++) {
    for (let j = i + 1; j < visits.length; j++) {
      if (distanceBetweenLocations(visits[i].latitudeAddress, visits[i].longitudeAddress, visits[j].latitudeAddress, visits[j].longitudeAddress) < 0.02) {
        visits[i].duplicateAddress = visits[j].duplicateAddress = true;
      }
    }
  }

  return visits;
}

export function visitsReducer(state: VisitsState = initialState, action: ReduxAction<any>): VisitsState {
  switch (action.type) {
    case VisitsAction.SET_IS_FETCHING:
      return {
        ...state,
        visits: setAsyncData(state.visits, (v) => (v.isFetching = action.data as boolean)),
      };
    case UIAction.SET_VISIT_CODE:
      // when the visit changes, whatever claim may have been loaded in the side panel is no longer relevent
      return {
        ...state,
        visitSideCardClaim: undefined,
      };
    case VisitsAction.SET_VISITS:
      const visits = action.data as Visit[];
      const visitCodeToVisitIndex: { [code: string]: number } = {};
      visits.forEach((v, i) => (visitCodeToVisitIndex[v.visitCode] = i));
      return {
        ...state,
        visits: setAsyncData(state.visits, (v) => (v.data = updateVisitsDuplicateAddress(action.data as Visit[]))),
        visitCodeToVisitIndex,
      };

    case VisitsAction.SET_VISIT:
      const visit = action.data as Visit;
      if (visit) {
        const index = state.visitCodeToVisitIndex[visit.visitCode];
        return {
          ...state,
          visits: setAsyncData(state.visits, (v) => {
            const newVisits = v.data ? v.data.slice() : [];
            newVisits[index] = visit;
            v.data = updateVisitDuplicateAddress(newVisits, index);
          }),
        };
      }
      return { ...state };

    case ClaimsAction.ONE_UPDATED:
      const c: Claim = action.data as Claim;
      return {
        ...state,
        visitSideCardClaim: c,
      };

    case VisitsAction.SET_VISIT_CONFIG_FETCHING:
      return {
        ...state,
        visitConfig: setAsyncData(state.visitConfig, (v) => (v.isFetching = action.data as boolean)),
      };

    case VisitsAction.SET_VISIT_CONFIG:
      return {
        ...state,
        visitConfig: setAsyncData(state.visitConfig, (v) => (v.data = action.data as Properties)),
      };

    case VisitsAction.SET_AVAILABLE_TIME_SLOTS_FETCHING:
      return {
        ...state,
        availableTimeSlots: setAsyncData(state.availableTimeSlots, (v) => (v.isFetching = action.data)),
      };

    case VisitsAction.SET_AVAILABLE_TIME_SLOTS:
      return {
        ...state,
        availableTimeSlots: setAsyncData(state.availableTimeSlots, (v) => (v.data = action.data.value as TimeSlot[])),
      };

    case VisitsAction.SET_CANCEL_REASONS:
      return {
        ...state,
        cancelReasons: {
          data: action.data,
          isFetching: false,
          error: undefined,
        },
      };

    case VisitsAction.SET_CANCEL_REASONS_FETCHING:
      return {
        ...state,
        cancelReasons: {
          ...state.cancelReasons,
          isFetching: true,
          error: undefined,
        },
      };

    default:
      return state;
  }
}
